import { Pipe, PipeTransform } from '@angular/core';
import { QuestionType } from '@hyper-inferno/survey-elements-core';

function getQuestionTypeName(type: QuestionType): string {
  switch (type) {
    // Choice Types
    case QuestionType.SINGLE_CHOICE:
      return 'Single Choice';

    case QuestionType.MULTIPLE_CHOICE:
      return 'Multiple Choice';

    case QuestionType.DROP_DOWN_SINGLE_CHOICE:
      return 'Dropdown Single Choice';

    case QuestionType.DROP_DOWN_MULTIPLE_CHOICE:
      return 'Dropdown Multiple Choice';

    // Text Types
    case QuestionType.OPEN_ENDED:
      return 'Open Ended';

    case QuestionType.NUMERIC:
      return 'Numeric';

    // Media Types
    case QuestionType.IMAGE:
      return 'Image';

    case QuestionType.VIDEO:
      return 'Video';

    case QuestionType.VOICE:
      return 'Voice';

    case QuestionType.FILE:
      return 'File Upload';

    // Grid Types
    case QuestionType.SINGLE_GRID:
      return 'Single Grid';

    case QuestionType.MULTIPLE_GRID:
      return 'Multiple Grid';

    case QuestionType.MIXED_GRID:
      return 'Mixed Grid';

    // Ranking
    case QuestionType.CLICK_TO_RANK:
      return 'Click to Rank';

    // Logic & Other
    case QuestionType.SKIP_LOGIC:
      return 'Skip Logic';

    case QuestionType.DISPLAY:
      return 'Display Text';

    case QuestionType.LOCATION:
      return 'Location';

    // Default Fallback
    default:
      if (type) {
        // Fallback: Converts "DROP_DOWN_SINGLE_CHOICE" to "Drop Down Single Choice" if a new type is added but not mapped
        return type
          .toString()
          .replace(/_/g, ' ')
          .replace(
            /\w\S*/g,
            (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
          );
      }
      return 'Unknown Type';
  }
}

@Pipe({
  name: 'questionTypeName',
  pure: true,
})
export class QuestionTypeNamePipe implements PipeTransform {
  transform(type?: string): string {
    return getQuestionTypeName(type as QuestionType);
  }
}
